
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"srcset"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetInterface"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"w1920"},"name":{"kind":"Name","value":"url"},"arguments":[],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"transform"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"1920"}}]}]},{"kind":"Field","alias":{"kind":"Name","value":"w1440"},"name":{"kind":"Name","value":"url"},"arguments":[],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"transform"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"1440"}}]}]},{"kind":"Field","alias":{"kind":"Name","value":"w1280"},"name":{"kind":"Name","value":"url"},"arguments":[],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"transform"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"1280"}}]}]},{"kind":"Field","alias":{"kind":"Name","value":"w980"},"name":{"kind":"Name","value":"url"},"arguments":[],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"transform"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"980"}}]}]},{"kind":"Field","alias":{"kind":"Name","value":"w768"},"name":{"kind":"Name","value":"url"},"arguments":[],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"transform"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"768"}}]}]},{"kind":"Field","alias":{"kind":"Name","value":"w520"},"name":{"kind":"Name","value":"url"},"arguments":[],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"transform"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"520"}}]}]},{"kind":"Field","alias":{"kind":"Name","value":"w380"},"name":{"kind":"Name","value":"url"},"arguments":[],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"transform"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"380"}}]}]},{"kind":"Field","alias":{"kind":"Name","value":"webp_w1920"},"name":{"kind":"Name","value":"url"},"arguments":[],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"transform"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"1920"}},{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"StringValue","value":"webp","block":false}}]}]},{"kind":"Field","alias":{"kind":"Name","value":"webp_w1440"},"name":{"kind":"Name","value":"url"},"arguments":[],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"transform"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"1440"}},{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"StringValue","value":"webp","block":false}}]}]},{"kind":"Field","alias":{"kind":"Name","value":"webp_w1280"},"name":{"kind":"Name","value":"url"},"arguments":[],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"transform"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"1280"}},{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"StringValue","value":"webp","block":false}}]}]},{"kind":"Field","alias":{"kind":"Name","value":"webp_w980"},"name":{"kind":"Name","value":"url"},"arguments":[],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"transform"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"980"}},{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"StringValue","value":"webp","block":false}}]}]},{"kind":"Field","alias":{"kind":"Name","value":"webp_w768"},"name":{"kind":"Name","value":"url"},"arguments":[],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"transform"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"768"}},{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"StringValue","value":"webp","block":false}}]}]},{"kind":"Field","alias":{"kind":"Name","value":"webp_w520"},"name":{"kind":"Name","value":"url"},"arguments":[],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"transform"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"520"}},{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"StringValue","value":"webp","block":false}}]}]},{"kind":"Field","alias":{"kind":"Name","value":"webp_w380"},"name":{"kind":"Name","value":"url"},"arguments":[],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"transform"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"width"},"value":{"kind":"IntValue","value":"380"}},{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"StringValue","value":"webp","block":false}}]}]}]}}],"loc":{"start":0,"end":716}};
    doc.loc.source = {"body":"fragment srcset on AssetInterface {\n    w1920: url @transform(width: 1920)\n    w1440: url @transform(width: 1440)\n    w1280: url @transform(width: 1280)\n    w980: url @transform(width: 980)\n    w768: url @transform(width: 768)\n    w520: url @transform(width: 520)\n    w380: url @transform(width: 380)\n\n    webp_w1920: url @transform(width: 1920, format: \"webp\")\n    webp_w1440: url @transform(width: 1440, format: \"webp\")\n    webp_w1280: url @transform(width: 1280, format: \"webp\")\n    webp_w980: url @transform(width: 980, format: \"webp\")\n    webp_w768: url @transform(width: 768, format: \"webp\")\n    webp_w520: url @transform(width: 520, format: \"webp\")\n    webp_w380: url @transform(width: 380, format: \"webp\")\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["srcset"] = oneQuery(doc, "srcset");
        
